import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminEvaluation';

const Table21 = withTableController(({
  planing,
  handlePlaning,
  childToParent,
  status
}) => (
  <Plan
    planing={planing}
    handlePlaning={handlePlaning}
    childToParent={childToParent}
    status={status}
  />
));

export default Table21;
